module.exports = __webpack_public_path__ + "img/jt4.ddfe6738.png";